import axios from 'axios';

export default class FormContact {
  constructor() {
    if (this.setVars()) this.setEvent();
  }
  
  setVars() {
    this.settings = {
      form: 'data-form-contact',
      input: 'data-form-contact-input',
      submit: 'data-form-contact-submit',
      message: 'data-form-contact-message',
    }
    this.forms = document.querySelectorAll(`[${this.settings.form}]`);
    return this.forms;
  }
  
  setEvent() {
    this.forms.forEach(form => {
      const message = form.querySelector(`[${this.settings.message}]`);
      
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        e.stopPropagation();
        message.removeClass('success');
        message.removeClass('error');
        message.innerHTML = '';
        
        let data = new FormData();
        data.append('action', 'coonpek');
        data.append('nonce', ajax.nonce);
        data.append('phone', form.querySelector(`[${this.settings.input}]`).value);
  
        axios.post(ajax.url, data)
          .then( (response) => {
            message.addClass(response.data.status);
            message.innerHTML = response.data.message;
            form.querySelector(`[${this.settings.input}]`).value = '';
          })
          .catch(function (error) {
            console.log(error);
          });
      })
    })
  }
}
